import { Link, useLocation } from 'react-router-dom';
import useWindowSize from '../hooks/useWindowSize';

/**
 * Componente de navegación del entrenador
 * Se muestra en todas las páginas cuando el usuario está logueado como coach
 * Sigue el mismo patrón que PlayerNavigation
 */
const CoachNavigation = () => {
  const location = useLocation();
  const { width, isMobile } = useWindowSize();

  // Detectar pantallas muy pequeñas (solo cuando realmente no caben las palabras)
  const isVerySmall = width <= 360;

  // Función para verificar si una ruta está activa
  const isActive = (path) => {
    return location.pathname === path || 
           (path === '/coach/dashboard' && location.pathname === '/coach');
  };

  // Estilo base para los enlaces
  const getLinkStyle = (path) => ({
    color: isActive(path) ? '#4352A9' : '#495057',
    textDecoration: 'none',
    fontSize: isVerySmall ? '10px' : isMobile ? '11px' : '14px',
    fontWeight: isActive(path) ? '600' : '500',
    padding: isVerySmall ? '3px 4px' : isMobile ? '4px 6px' : '10px 16px',
    borderRadius: '4px',
    backgroundColor: isActive(path) ? 'rgba(67, 82, 169, 0.1)' : 'transparent',
    border: isActive(path) ? '1px solid #4352A9' : '1px solid #e1e5e9',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    gap: isVerySmall ? '2px' : isMobile ? '3px' : '6px',
    flex: isMobile ? '0 1 auto' : 'none',
    minWidth: isMobile ? 'auto' : 'auto',
  });

  // Efectos hover
  const handleMouseOver = (e, path) => {
    if (!isActive(path)) {
      e.target.style.backgroundColor = 'rgba(67, 82, 169, 0.05)';
      e.target.style.borderColor = '#4352A9';
    }
  };

  const handleMouseOut = (e, path) => {
    if (!isActive(path)) {
      e.target.style.backgroundColor = 'transparent';
      e.target.style.borderColor = '#e1e5e9';
    }
  };

  return (
    <div style={{
      width: '100%',
      borderBottom: '1px solid #e1e5e9',
      backgroundColor: '#ffffff',
      position: 'relative',
      zIndex: 10,
      marginBottom: isMobile ? '16px' : '32px',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isVerySmall ? '6px 8px' : isMobile ? '8px 16px' : '20px 24px',
      }}>
        <nav style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: isVerySmall ? '4px' : isMobile ? '6px' : '16px',
          justifyContent: isMobile ? 'center' : 'flex-start',
          alignItems: 'center',
        }}>
          
          {/* Dashboard */}
          <Link
            to="/coach/dashboard"
            style={getLinkStyle('/coach/dashboard')}
            onMouseOver={(e) => handleMouseOver(e, '/coach/dashboard')}
            onMouseOut={(e) => handleMouseOut(e, '/coach/dashboard')}
          >
            <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
              dashboard
            </span>
            {isVerySmall ? 'D' : 'Dashboard'}
          </Link>

          {/* Mis Partidos */}
          <Link
            to="/coach/partidos"
            style={getLinkStyle('/coach/partidos')}
            onMouseOver={(e) => handleMouseOver(e, '/coach/partidos')}
            onMouseOut={(e) => handleMouseOut(e, '/coach/partidos')}
          >
            <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
              sports_soccer
            </span>
            {isVerySmall ? 'P' : 'Mis Partidos'}
          </Link>

          {/* ProPoints */}
          <Link
            to="/coach/evaluaciones"
            style={getLinkStyle('/coach/evaluaciones')}
            onMouseOver={(e) => handleMouseOver(e, '/coach/evaluaciones')}
            onMouseOut={(e) => handleMouseOut(e, '/coach/evaluaciones')}
          >
            <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
              star
            </span>
            {isVerySmall ? 'PP' : 'ProPoints'}
          </Link>

          {/* Perfil */}
          <Link
            to="/coach/perfil"
            style={getLinkStyle('/coach/perfil')}
            onMouseOver={(e) => handleMouseOver(e, '/coach/perfil')}
            onMouseOut={(e) => handleMouseOut(e, '/coach/perfil')}
          >
            <span className="material-icons" style={{ fontSize: isVerySmall ? '10px' : isMobile ? '12px' : '16px' }}>
              person
            </span>
            {isVerySmall ? 'P' : 'Mi Perfil'}
          </Link>

        </nav>
      </div>
    </div>
  );
};

export default CoachNavigation;
